var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"checkmark"},[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#1BE3AD","fillOpacity":"0.15","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"23","height":"23","rx":"11.5","stroke":"#1BE3AD","strokeOpacity":"0.3","key":1}),React.createElement("path",{"id":"Vector","d":"M16.3 8.3L10 14.6L7.7 12.3C7.3 11.9 6.7 11.9 6.3 12.3C5.9 12.7 5.9 13.3 6.3 13.7L9.3 16.7C9.5 16.9 9.7 17 10 17C10.3 17 10.5 16.9 10.7 16.7L17.7 9.7C18.1 9.3 18.1 8.7 17.7 8.3C17.3 7.9 16.7 7.9 16.3 8.3Z","fill":"#1BE3AD","key":2})]));
}

Checkmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
